module.exports = __webpack_public_path__ + "static/img/8.1a12d857.png";